import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const Content = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  margin: 1rem 1.5rem;
  padding: 1rem;
  width: -webkit-fill-available;
  border-radius: 16px;
  .title {
    font-size: 1.6rem;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.secondary};

    p {
      margin: 0;
    }
  }

  .container-cities {
    p {
      font-size: 1.2rem;
      font-weight: bold;
      color: ${({ theme }) => theme.colors.primary};
    }

    .new-cities {
      display: flex;

      p {
        margin: 0;
      }

      button {
        background-color: transparent;
        border: none;
        svg {
          fill: ${({ theme }) => theme.colors.tertiary_500} !important;
        }
      }

      button:hover {
        cursor: pointer;
        svg {
          fill: ${({ theme }) => theme.colors.primary} !important;
        }
      }
    }

    .cities-user {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      max-width: 100rem;
      max-height: 15rem;
      overflow-y: auto;

      .empty-cities {
        color: ${({ theme }) => theme.colors.text};
        font-weight: 300;
        font-size: 24;
        margin: 0.5rem 0;

        a {
          color: ${({ theme }) => theme.colors.text};
          font-weight: 600;
        }
      }
    }
  }

  @media (max-width: 320px) {
    margin: 0.5rem;
    padding: 0.5rem;
  }

  .container-button-save {
    display: flex;
    justify-content: flex-end;
    padding: 1rem;
    margin: 1rem 0;
  }

  @media (max-width: 600px) {
    .container-button-save {
      justify-content: center;
      display: flex;
    }
  }
`;

export const LineFlat = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  opacity: 0.6;
  height: 2px;
`;

export const ContainerValues = styled.div`
  margin-top: 15px;
  max-height: 46.5rem;
  overflow-y: auto;

  p {
    font-size: 18px;
    font-family: 'Futura PT';
    letter-spacing: 0px;
    color: ${({ theme }) => theme.colors.secondary};
    opacity: 1;
  }

  .empty-specialties {
    color: ${({ theme }) => theme.colors.text};
    font-weight: 300;
    font-size: 24;
    margin-top: 0.5rem;

    a {
      color: ${({ theme }) => theme.colors.text};
      font-weight: 600;
    }
  }
`;

export const Panel = styled.div`
  margin-top: 10px;
  padding: 0 1rem;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.background};
  .container-accordion-expanded {
    .divHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        font-family: 'Segoe UI';
        font-size: 20px;
        letter-spacing: 0px;
        color: ${({ theme }) => theme.colors.primary};
        opacity: 1;
        font-weight: 500 !important;
      }
    }

    .content {
      display: flex;
      margin-top: 10px;

      .center {
        width: 70%;
        display: flex;
        justify-content: center;
        align-items: center;

        .empty-correspondences {
          color: ${({ theme }) => theme.colors.text};
          font-weight: 300;
          font-size: 24;
          margin-top: 0.5rem;

          a {
            color: ${({ theme }) => theme.colors.text};
            font-weight: 600;
          }
        }
      }

      .container-services {
        width: 80%;
        display: flex;
        flex-wrap: wrap;
        max-height: 15rem;
        overflow-y: auto;
        gap: 0.5rem;
        margin: 1rem;
        padding: 0.5rem;
        border-radius: 0.5rem;
        box-shadow: 1px 2px 6px rgb(0 0 0 / 20%);
        .services {
          width: 40%;
          margin-right: 1rem;
          .inputMoney {
            display: flex;
            align-items: center;
            width: 100%;
            .inputMoneyValue {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .correspondenceName {
              display: flex;
              font-family: 'Futura PT';
              font-weight: 300;
              font-size: 1rem;
              color: ${({ theme }) => theme.colors.primary};
              opacity: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 100%;
            }

            p {
              font-family: 'Futura PT';
              font-weight: 300;
              font-size: 18px;
              color: ${({ theme }) => theme.colors.primary};
              opacity: 1;
            }
          }
        }
      }

      .container-apply-values {
        display: flex;
        flex-direction: column;
        margin-left: 5px;
        width: 27%;
        padding: 0 5px;
        position: relative;

        .apply-values-title {
          display: flex;
          flex-direction: row;
          align-items: center;

          svg {
            font-size: 22px;
            color: ${({ theme }) => theme.colors.primary};
          }

          p {
            font-family: 'Segoe UI';
            font-size: 20px;
            letter-spacing: 0px;
            color: ${({ theme }) => theme.colors.primary};
            opacity: 1;
            margin-bottom: 0.2rem;
            font-weight: 500 !important;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .apply-values-specialties-city {
          display: flex;
          flex-direction: column;

          button {
            width: fit-content;
            color: ${({ theme }) => theme.colors.tertiary_500};
            border: none;
            background: none;
            padding: 0;
            margin: 15px 0 0 5px;
            font-size: 1rem;
            display: flex;
            align-items: center;

            svg {
              font-size: 18px;
              margin: 0 0 0 5px;
            }
          }

          button:hover {
            cursor: pointer;
          }

          button &:focus-visible {
            outline: none;
          }
        }

        .container-apply {
          width: 100%;
          display: flex;
          justify-content: center;

          button {
            width: 4rem;
            background: ${({ theme }) => theme.colors.background};
            border: 1px solid ${({ theme }) => theme.colors.tertiary_500};
            border-radius: 10px;
            opacity: 1;
            align-self: end;
            font-family: 'Futura PT';
            letter-spacing: 0px;
            color: ${({ theme }) => theme.colors.tertiary_500};
            opacity: 1;
            margin-top: 0.5rem;
          }

          button:hover {
            background: ${({ theme }) => theme.colors.tertiary_500};
            color: ${({ theme }) => theme.colors.background};
          }
        }
      }
    }
  }

  @media (max-width: 1100px) {
    .container-accordion-expanded .content .container-services .services {
      width: 50%;
    }
  }

  @media (max-width: 750px) {
    .container-accordion-expanded .content .container-services {
      flex-direction: row;

      .services {
        width: 100%;
      }
    }
  }

  @media (max-width: 600px) {
    .container-accordion-expanded .content {
      flex-direction: column;
      gap: 0.5rem;
      width: 80%;

      .container-services {
        flex-direction: column;
        gap: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90%;
        margin-right: 0;
      }

      .container-apply-values {
        width: 100%;
        padding: 0;
        margin: 0;
      }
    }
  }
`;

export const LineUpRight = styled.div`
  margin-left: 5px;
  border-left: 1px solid;
  box-sizing: border-box;
  color: gray;
  opacity: 0.6;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const PopoverContainer = styled.div`
  display: flex;
  justify-items: flex-start;
  padding: 5px;
  height: 10rem;
  display: grid;
  gap: 0.5rem;

  .mark-unmark {
    display: flex;
    justify-content: space-evenly;

    button {
      text-decoration: underline;
      font-size: 18px;
      font-family: 'Futura PT';
      border: none;
      background: none;
      letter-spacing: -0.3px;
      color: ${({ theme }) => theme.colors.tertiary_500};
      opacity: 1;
    }
  }

  .specialties-city {
    display: flex;
    flex-direction: row;
    align-items: center;

    span {
      font-size: 18px;
      font-family: 'Futura PT';
      letter-spacing: 0px;
      color: ${({ theme }) => theme.colors.secondary};
      opacity: 1;
    }
  }

  .MuiCheckbox-colorSecondary {
    color: ${({ theme }) => theme.colors.tertiary_500} !important;
  }

  .Mui-checked {
    svg {
      fill: ${({ theme }) => theme.colors.tertiary_500};
    }
  }
`;
